import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SimpleModal } from '@sequencehq/core-components'
import { useState } from 'react'
import { useNotifications } from '@sequencehq/core-components'
import { UsageMetricForm, UsageMetricInput } from './UsageMetricForm'

interface Props {
  isOpen?: boolean
  onClose: () => void
  onCreate?: (createdUsageMetric: { id: string; name: string }) => void
}

export const CreateUsageMetricDrawer = ({
  isOpen = true,
  onClose,
  onCreate
}: Props) => {
  const createMetricMutation = useMutation(
    dashboard20240730Client.postUsageMetric
  )
  const { displayNotification } = useNotifications()
  const [formData, setFormData] = useState<UsageMetricInput | null>(null)
  const [formIsValid, setFormIsValid] = useState(false)
  const [showValidationErrors, setShowValidationErrors] = useState(false)

  const handleSubmit = async () => {
    if (!formData) return false
    if (!formIsValid) {
      setShowValidationErrors(true)
      return false
    }

    try {
      const response = await createMetricMutation.mutateAsync({
        body: formData
      })

      if (response) {
        displayNotification('Usage metric created successfully', {
          type: 'success'
        })

        onCreate?.({ id: response.id, name: formData.name })
        onClose()
        return true
      }

      displayNotification('Failed to create usage metric', {
        type: 'error'
      })
      return false
    } catch {
      displayNotification('Failed to create usage metric', {
        type: 'error'
      })
      return false
    }
  }

  return (
    <SimpleModal
      data-testid="usageMetric.drawer"
      isOpen={isOpen}
      onClose={onClose}
      variant="drawer"
      title="Add usage metric"
      cancelButtonText="Cancel"
      submitButtonText="Add usage metric"
      submittingButtonText="Adding usage metric..."
      submitDisabled={createMetricMutation.isPending}
      onSubmit={handleSubmit}
    >
      <UsageMetricForm
        initialValues={null}
        onChange={setFormData}
        onValidationChange={setFormIsValid}
        showValidationErrors={showValidationErrors}
      />
    </SimpleModal>
  )
}
